export const buttonVariants = ['theme', 'theme-inverse', 'primary', 'secondary', 'top-nav', 'white', 'tag-white'] as const

export type ButtonVariant = (typeof buttonVariants)[number]

export function isButtonVariant(variant: string): variant is ButtonVariant {
  return buttonVariants.includes(variant as ButtonVariant)
}
